/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetMedicalIntakeErrorResponse, GetMedicalIntakeResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersMedicalIntake = (encounterId: number, signal?: AbortSignal) => {
  return api<GetMedicalIntakeResponse>({
    url: `/api/encounters/${encounterId}/medical-intake`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersMedicalIntakeQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/medical-intake`] as const;
};

export const getGetEncountersMedicalIntakeQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
  TError = GetMedicalIntakeErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalIntake>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersMedicalIntakeQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersMedicalIntake>>> = ({
    signal,
  }) => getEncountersMedicalIntake(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersMedicalIntakeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersMedicalIntake>>
>;
export type GetEncountersMedicalIntakeQueryError = GetMedicalIntakeErrorResponse;

export function useGetEncountersMedicalIntake<
  TData = Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
  TError = GetMedicalIntakeErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalIntake>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
          TError,
          Awaited<ReturnType<typeof getEncountersMedicalIntake>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersMedicalIntake<
  TData = Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
  TError = GetMedicalIntakeErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalIntake>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
          TError,
          Awaited<ReturnType<typeof getEncountersMedicalIntake>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersMedicalIntake<
  TData = Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
  TError = GetMedicalIntakeErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalIntake>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersMedicalIntake<
  TData = Awaited<ReturnType<typeof getEncountersMedicalIntake>>,
  TError = GetMedicalIntakeErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalIntake>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersMedicalIntakeQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
